import { AccountIcon } from 'assets/icons';
import type { MouseEventHandler } from 'react';
export default function UserAvatar({
  user,
  className = '',
  alt = 'initials',
  theme = 'gray',
  size = 'w-10 h-10 md-max:h-7 md-max:w-7 text-sm md-max:text-xs',
  rounded = 'rounded-full',
  onClick,
}: {
  user?: { given_name?: string; family_name?: string; picture_url?: string };
  className?: string;
  alt?: 'icon' | 'initials';
  theme?: 'gray' | 'green';
  size?: string;
  rounded?: string;
  onClick?: MouseEventHandler<HTMLDivElement>;
}) {
  return (
    <div
      onClick={onClick}
      className={`shadow border border-white ${rounded} ${size} shrink-0 overflow-hidden ${className}`}
    >
      {user?.picture_url ? (
        <img
          src={`${process.env.REACT_APP_URL}${user.picture_url}`}
          alt="profilePicture"
          className=" h-full"
        />
      ) : (
        <>
          {alt === 'initials' && user?.given_name && user?.family_name ? (
            <div
              className={`${
                theme === 'green' ? 'bg-green bg-opacity-20' : ' bg-gray-150'
              } ${
                theme === 'green' ? 'text-green' : 'text-gray-dark'
              } uppercase h-full w-full flex justify-center items-center font-bold `}
            >
              {user?.given_name[0]}
              {user?.family_name[0]}
            </div>
          ) : (
            <AccountIcon />
          )}
        </>
      )}
    </div>
  );
}
